import { storage } from '@/utils/storageOperateApi';
import { LOCAL_STORAGE_KEY } from '@/constants';

/** 判断是否Mac客户端 */
export const isMac = /macintosh|mac os x/i.test(window.navigator.userAgent);

/** 判断是否windows客户端 */
export const isWindows = /windows|win32/i.test(navigator.userAgent);

export const getSystemName = () => {
  if (isWindows) {
    return 'Windows';
  } else if (isMac) {
    return 'Mac';
  } else {
    return ' ';
  }
};

export const getBrowserVersion = (type) => {
  const agent = navigator.userAgent.toLowerCase();
  const regStr_ie = /msie [\d.]+;/gi;
  const regStr_ff = /firefox\/[\d.]+/gi;
  const regStr_chrome = /chrome\/[\d.]+/gi;
  const regStr_saf = /safari\/[\d.]+/gi;
  const regStr_wexin = /MicroMessenger\/([\d\.]+)/gi;

  const regMap = {
    Ie: regStr_ie,
    Firefox: regStr_ff,
    Chrome: regStr_chrome,
    Safari: regStr_saf,
    exin: regStr_wexin
  };
  const browser = agent.match(regMap[type]);

  return (browser + '').replace(/[^0-9.]/gi, '');
};

export const getBrowserInfo = () => {
  const agent = navigator.userAgent.toLowerCase();
  let browser = '';
  let version = '';
  // wechat
  if (agent.indexOf('micromessenger') > 0) {
    browser = 'Wexin';
    version = getBrowserVersion(browser);
    return {
      browser,
      version
    };
  }

  // IE
  if (agent.indexOf('msie') > 0) {
    browser = 'Ie';
    version = getBrowserVersion(browser);
    return {
      browser,
      version
    };
  }

  //firefox
  if (agent.indexOf('firefox') > 0) {
    browser = 'Firefox';
    version = getBrowserVersion(browser);
    return {
      browser,
      version
    };
  }

  //Safari
  if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
    browser = 'Safari';
    version = getBrowserVersion(browser);
    return {
      browser,
      version
    };
  }

  //Chrome
  if (agent.indexOf('chrome') > 0) {
    browser = 'Chrome';
    version = getBrowserVersion(browser);
    return {
      browser,
      version
    };
  }

  return {
    browser,
    version
  };
};

export const getDeviceName = () => {
  return getBrowserInfo().browser;
};

// UUID生成函数
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/** 获取或创建设备标识，用于记录搜索记录 */
export const getOrCreateDeviceId = () => {
  const STORAGE_KEY = LOCAL_STORAGE_KEY.APP_DEVICE_ID;
  let deviceId = storage.get(STORAGE_KEY);
  if (!deviceId) {
    deviceId = generateUUID();
    storage.set(STORAGE_KEY, deviceId, null, false, false);
  }
  return deviceId;
};
